// extracted by mini-css-extract-plugin
export var drawerPaper = "_26-0";
export var itemCard = "_26-1";
export var itemImage = "_26-2";